import { Box } from "@mui/material";
import { Question1 } from "./Question1";
import { Question2 } from "./Question2";
import { Question3 } from "./Question3";

export const Blog = () => {
  return (
    <Box>
      <Question1 />
      <Question2 />
      <Question3 />
    </Box>
  );
};
